import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const { user, isLoading } = useContext(AuthContext);

    if (isLoading) return null; // Prevents premature redirection

    return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
